"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    inbox: 'inbox',
    reviews: 'reviews',
};
